<template>
  <div class="home">
    <HomePc v-if="isPc"></HomePc>
    <HomeM v-else></HomeM>
  </div>
</template>

<script>
import HomePc from "./components/home_pc.vue";
import HomeM from "./components/home_m.vue";
import { mapState } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {};
  },
  computed: {
    ...mapState(["innerWidth", "isPc"])
  },
  components: {
    HomePc,
    HomeM
  }
};
</script>
